const AvailableSpeedOptions = [
  { value: 250, units: 'Mbps', label: '250 Megabit' },
  { value: 500, units: 'Mbps', label: '500 Megabit' },
  { value: 750, units: 'Mbps', label: '750 Megabit' },
  { value: 1, units: 'Gbps', label: 'Gigabit' },
  { value: 1.5, units: 'Gbps', label: '1.5 Gigabit' },
  { value: 3, units: 'Gbps', label: '3 Gigabit' },
  { value: 5, units: 'Gbps', label: '5 Gigabit' },
  { value: 10, units: 'Gbps', label: '10 Gigabit' },
  { value: 0, units: '', label: 'custom' }
];

export default AvailableSpeedOptions;
